import { render, staticRenderFns } from "./AdresseForm.vue?vue&type=template&id=4c56b16c&scoped=true"
import script from "./AdresseForm.vue?vue&type=script&lang=js"
export * from "./AdresseForm.vue?vue&type=script&lang=js"
import style0 from "./AdresseForm.vue?vue&type=style&index=0&id=4c56b16c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c56b16c",
  null
  
)

export default component.exports